import React from 'react';
import {Link} from 'react-router-dom';
import {ObjectPropertyDetails} from "../../../types/Object";
import {ShowMore} from "../../../common/show-more/ShowMore";
import {ObjectContext} from "../context/ObjectContext";
import {FieldKind} from "../../../types/GraphQlSchema";
import {getObjectViewPageUrl} from "../../../pages/object/ObjectViewPage";
import ObjectsService, { MoreObjectsResponse } from '../../../services/objects-service';

const DEFAULT_OBJECTS_LIMIT = 10;
const LOAD_MORE_SIZE = DEFAULT_OBJECTS_LIMIT;

type ObjectPropertyViewProps = {
  property: ObjectPropertyDetails
}

type ObjectPropertyViewState = {
  offset: number
  loading: boolean
  loadMore: boolean
}

export default class ObjectPropertyView extends React.Component<ObjectPropertyViewProps, ObjectPropertyViewState> {

  static contextType = ObjectContext;

  constructor(props: ObjectPropertyViewProps) {
    super(props);
    this.state = {
      offset: 0,
      loading: false,
      loadMore: props.property.value.length === DEFAULT_OBJECTS_LIMIT
    };
  }

  static canHandle(property: ObjectPropertyDetails): boolean {
    return (property.graphQlFieldRef.kind === FieldKind.OBJECT ||
      property.graphQlFieldRef.kind === FieldKind.INTERFACE) && property.type !== "Literal";
  }

  loadNext = () => {
    const { details } = this.context;
    this.setState({ loading: true });
    ObjectsService.loadMoreObjects({
      objectId: details.id,
      type: details.graphQlTypeRef,
      field: this.props.property.graphQlFieldRef,
      limit: 10,
      offset: this.state.offset + LOAD_MORE_SIZE
    }).then((response: MoreObjectsResponse) => {
        const objects = response.objects;
        this.props.property.value.push(...objects);
        this.setState({
          offset: this.state.offset + LOAD_MORE_SIZE,
          loadMore: objects.length === LOAD_MORE_SIZE
        });
      }).finally(() => this.setState({ loading: false }));
  };

  renderMultiObject(values: any, forceNewTabs: boolean) {
    const objects = values.map((value: any, index: number) => {
      return <li key={index}>{renderSingleObject(value, forceNewTabs)}</li>;
    });
    return <ul>
      <ShowMore elements={objects} 
                minSize={DEFAULT_OBJECTS_LIMIT}
                disabled={this.state.loading}
                loader={this.state.loading}
                loadMore={this.state.loadMore} 
                loadMoreSize={LOAD_MORE_SIZE}
                onLoadMore={this.loadNext}/>
      </ul>;
  }

  render() {
    const property = this.props.property;
    const forceNewTabs = this.context.forceNewTabs || false;

    if (property.multi) {
      if (property.value.length < 2) {
        return renderSingleObject(property.value[0], forceNewTabs);
      }
      return this.renderMultiObject(property.value, forceNewTabs);
    }
    return renderSingleObject(property.value, forceNewTabs);
  }
}

function renderSingleObject(value: any, forceNewTabs: boolean) {
  const {id, name} = value;
  const linkTo = getObjectViewPageUrl(id);
  const target = forceNewTabs ? '_blank' : '';
  return <Link to={linkTo} target={target}>{name || id}</Link>;
}
